import { motion } from 'framer-motion';
import EditClinicComponent from 'src/components/EditClinic';

const EditClinic = () => {
  return (
    <motion.div
      animate={{ opacity: 1, transition: { duration: 1 } }}
      initial={{ opacity: 0 }}
    >
      <EditClinicComponent />
    </motion.div>
  );
};

export default EditClinic;
